export enum RequirementsNpaSourceEnum {
  ROT = 'ROT',
  CUSTOM = 'CUSTOM',
}
